import { createLucideIcon } from "lucide-react";

export const WalletRemove = createLucideIcon(
    "WalletRemove",
    [
        [
            "path",
            {
                d: "M10 16L4 22",
                key: "1b523j",
            },
        ],
        [
            "path",
            {
                d: "M10 22L4 16",
                key: "xwbuh5",
            },
        ],
        [
            "path",
            {
                d: "M15 15C15 15.8284 15.6716 16.5 16.5 16.5C17.3284 16.5 18 15.8284 18 15C18 14.1716 17.3284 13.5 16.5 13.5C15.6716 13.5 15 14.1716 15 15Z",
                key: "yrf005",
            },
        ],
        [
            "path",
            {
                d: "M17.6258 8.00006C18.0035 6.57679 18.3453 3.98828 17.327 2.70298C16.6816 1.88833 15.7223 1.9666 14.7818 2.04932C9.83791 2.48412 6.34544 3.36737 4.39301 3.96744C3.55348 4.22546 3 5.04528 3 5.9605",
                key: "1ttcrs",
            },
        ],
        [
            "path",
            {
                d: "M3 12.5V6C5.1047 6.62133 9.57619 7.42671 15.0038 7.80281C17.9252 8.00525 19.3859 8.10646 20.1929 8.97688C21 9.8473 21 11.2497 21 14.0546V16.0683C21 18.9566 21 20.4008 20.0163 21.2998C19.0325 22.1987 17.6919 22.0677 15.0106 21.8058C14.3572 21.7419 13.6846 21.666 13 21.5762",
                key: "sps72p",
            },
        ],
    ],
);
